import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormGroup, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';
import Swal from 'sweetalert2'


import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { roles } from '../../../../Shared/utils';
import { update, get } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { multiSelectStrings } from '../../../../Functions/utils';
import { useReportingContext } from '../../../../Context/Reporting/Provider';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { toastTimerValue } from '../../../../Shared/utils';
import '../../../SweetAlert.css'

//                      UpdateAccount({users, setUsers, selectedUser, setSelectedUser}) {
export default function UpdateLicense({ licenses, setLicenses, selectedLicense, setSelectedLicense }) {
  const { t } = useTranslation();
  const [{user}] = useAppContext();
  const [{pickers}] = useReportingContext();

  const tmpLocations = JSON.parse(JSON.stringify(pickers.locations.all));
  const locations = tmpLocations.map(loc => { loc.label = loc.label.replace(/\u2001/g, ''); return loc; });

  const [loading, setLoading] = useState(false);
  const [newLicense, setNewLicense] = useState({
    ...selectedLicense, // if loc.group doesn't exist -> not a location
    });


  const handleEditLicense = (e, license) => {
    e.preventDefault();
    return;

    setLoading(true);
    license.uuid = license.uuid.replace(/[^0-9a-fA-F]/g, '');

    update({ type: 'license', license }).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { id: license.id })), { type: 'error' });
      }

      const newLicenses = licenses.slice(); // .slice() creates a new array
      for (const [index, row] of newLicenses.entries()) {
        if (row.id === res.license.id) {
          newLicenses[index] = { ...res.license }; break;
        }
        }

      // update default accounts sorting in case of username change
      setLicenses(newLicenses.sort((a, b) => a.email.localeCompare(b.email)));

      setSelectedLicense(null);
      toast(decodeHTMLEntities(t('admin.licenses.update.success', { id: license.id })), { type: 'success' });
    });
  };


  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleEditLicense(e, newLicense)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.licenses.update.title')}</h1>
            <div>
              <select
                disabled
                value={newLicense.Product_id}
                className="singleSelect"
                title={t('admin.licenses.columns.type')}
                onChange={e => {
                  setNewLicense({ ...newLicense, Product_id: Number(e.target.value) });
                }}
                  >
                <option value="1" disabled={true}>{t('admin.licenses.type_SDS')}</option>
                <option value="2" >{t('admin.licenses.type_MacRestorer')}</option>
                <option value="3" disabled={true}>{t('admin.licenses.type_Chromebook_solution')}</option>
                <option value="4" disabled={true}>{t('admin.licenses.type_Windows_Diagnostics')}</option>
                <option value="5" disabled={true}>{t('admin.licenses.type_SBAR')}</option>
                <option value="6" disabled={true}>{t('admin.licenses.type_OnDevice')}</option>
              </select>
              </div>
            </div>

          {newLicense.Product_id == 2 && (

            < div >
          <div className="prompt__content">
            <div className="flexRow">
              <div>
                    <p className="sidebar__label">{t('admin.licenses.columns.group')}</p>
                <select
                      disabled
                      value={newLicense.Group_id}
                  className="singleSelect"
                      onChange={e => {
                        const tmpLoc = locations.filter(loc => loc.group == Number(e.target.value) || null);
                        const firstLoc = tmpLoc !== null ? tmpLoc[0] && tmpLoc[0].value : null;
                        setNewLicense({ ...newLicense, Group_id: Number(e.target.value) || null, Location_id: firstLoc, locations: [] })
                      } // Replace "no group" by null
                      }
                    >
                  {pickers.groups.map(group => <option key={group.value} value={group.value}>{group.label}</option>)}
                </select>
                        </div>

                  <div>
                    <p className="sidebar__label">{t('admin.licenses.columns.location')}</p>
                    <select
                      value={newLicense.Location_id}
                      className="singleSelect"
                      disabled={true || !newLicense.Group_id}
                      onChange={e => setNewLicense({ ...newLicense, Location_id: Number(e.target.value) || null, locations: [] })} // Replace "no group" by null
                    >
                      {locations.filter(loc => loc.group == newLicense.Group_id).map(loc => <option key={loc.value} value={loc.value}>{loc.label}</option>)}
                    </select>
            </div>
            </div>

                <br />

                <div className="prompt__content">
              <TextField
                    InputProps={{ readOnly: true }}
              required
                    name="Server_Name"
              autoComplete="off"
                variant="outlined"
                    value={newLicense.Server_Name}
                    label={t('admin.licenses.columns.serverName')}
                    onChange={e => setNewLicense({ ...newLicense, Server_Name: e.target.value })}
              />
                </div>

                <br />

                <div className="flexRow">
              <TextField
                    InputProps={{ readOnly: true }}
                    required
                    name="Customer_id"
                    autoComplete="off"
                    variant="outlined"
                    value={newLicense.Customer_id}
                    label={t('admin.licenses.columns.customerId')}
                    onChange={e => {
                      let value = parseInt(e.target.value, 10);

                      if (!isNaN(value)) {
                        if (value > 4090) value = 4090;
                        if (value < 1) value = 1;
                        setNewLicense({ ...newLicense, Customer_id: value })
                      }
                      else if (e.target.value === "") {
                        setNewLicense({ ...newLicense, Customer_id: "" })
                      }
                      else {
                        setNewLicense({ ...newLicense, Customer_id: newLicense.Customer_id })
                      }
                }}
                  />

                  <TextField
                    required
                    name="Check_delay"
                autoComplete="off"
                    type="number"
                    InputProps={{ readOnly: true, inputProps: { min: 1, max: 30 } }}
              variant="outlined"
                    value={newLicense.Check_delay}
                    label={t('admin.licenses.columns.Check_delay')}
                    onChange={e => setNewLicense({ ...newLicense, Check_delay: e.target.value })}
              />

                  <TextField
                    required
                    name="GracePeriod"
                    autoComplete="off"
                    type="number"
                    InputProps={{ readOnly: true, inputProps: { min: 0, max: 7 } }}
                    variant="outlined"
                    value={newLicense.GracePeriod}
                    label={t('admin.licenses.columns.gracePeriod')}
                    onChange={e => setNewLicense({ ...newLicense, GracePeriod: e.target.value })}
                  />
                </div>

            <div className="flexRow">
              <TextField
                    InputProps={{ readOnly: true }}
                    required
                    name="hostserial"
                    autoComplete="off"
                variant="outlined"
                    value={newLicense.Serial}
                    label={t('admin.licenses.columns.serial')}
                    onChange={e => setNewLicense({ ...newLicense, Serial: e.target.value })}
                />

              <TextField
                    InputProps={{ readOnly: true }}
                    required
                    name="mbserial"
                    autoComplete="off"
                variant="outlined"
                    value={newLicense.Motherboard_serial_number}
                    label={t('admin.licenses.columns.motherboard_serial')}
                    onChange={e => setNewLicense({ ...newLicense, Motherboard_serial_number: e.target.value })}
                />
                </div>

              <TextField
                  InputProps={{ readOnly: true }}
                  required
                  name="uuid"
                  autoComplete="off"
                variant="outlined"
                  value={newLicense.UUID}
                  label={t('admin.licenses.columns.uuid')}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  onChange={e => setNewLicense({ ...newLicense, UUID: e.target.value })}
              />


                <div className="category">
                  <p className="sidebar__label">{t('admin.licenses.features') + ' (' + t('admin.licenses.type_MacRestorer') + ') '}</p>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_audit}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_audit: !newLicense.Feature_audit })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_audit_and_manual_inputs')}</label>
                  </div>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_diags}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_diags: !newLicense.Feature_diags })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_diags')}</label>
                  </div>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_wipe}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_wipe: !newLicense.Feature_wipe })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_wipe_and_restore')}</label>
                  </div>
            </div>
          </div>
            </div>
          )}

        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedLicense(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={true || loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.update')}
          </Button>
        </PromptActions>
      </form >
    </Prompt >
  );
}
